module.exports = __webpack_public_path__ + "img/98.5.da8beb4d.png";